/**
 * Entscheidungslogik für Fehlerbehandlung in der Akten-Abfrage (#411).
 *
 * Trennung von React-Hook (`useAktenPaginated`) und reiner Logik, damit wir
 * die "was zeigen wir / was loggen wir"-Entscheidung ohne React-Renderer
 * testen können.
 */

import {
  formatSupabaseError,
  isMissingColumnError,
  isSchemaCacheStale,
} from './supabase-errors';

export interface AktenErrorDecision {
  /** true → wie "leere Liste" behandeln (keine rote Fehlermeldung in der UI). */
  treatAsEmpty: boolean;
  /** Sichtbare Meldung für die UI; null wenn kein Error gezeigt werden soll. */
  userMessage: string | null;
  /** Empfohlenes Log-Level für die Konsole. */
  logLevel: 'warn' | 'error';
}

/**
 * Kurz nach der Migration für Issue #243 (`stellungnahme_status`) kann der
 * PostgREST-Schema-Cache noch stale sein. In dem Fall liefert die Query
 * PGRST204/PGRST205 bzw. einen "column does not exist"-Fehler zurück. Das ist
 * temporär — wir zeigen statt einer roten Fehlermeldung den normalen
 * Empty-State "Keine Akten gefunden".
 */
export function decideAktenErrorHandling(err: unknown): AktenErrorDecision {
  if (isSchemaCacheStale(err) || isMissingColumnError(err, 'stellungnahme_status')) {
    return { treatAsEmpty: true, userMessage: null, logLevel: 'warn' };
  }
  return {
    treatAsEmpty: false,
    userMessage: formatSupabaseError(err),
    logLevel: 'error',
  };
}
